module.exports = __webpack_public_path__ + "static/media/plan-B5c-mobile-en.e253d25b.png";